import { createRoutine } from 'redux-saga-routines'

export const SET = 'CONTACTO/SET'
export const CONTENT = createRoutine('CONTACTO/CONTENT')
export const SUBMIT = createRoutine('CONTACTO/SUBMIT')
